import { LicenseInfo } from '@mui/x-license-pro';
const license = import.meta.env.VITE_LICENSE_KEY_MUI;
// console.log(license)
LicenseInfo.setLicenseKey(`${license}`);
export default function MuiXLicense() {
  return null;
}
